<template>
  <el-popover placement="bottom-start" trigger="manual" v-model="isVisible">
    <div
      v-if="isVisible"
      class="sc-tagil-matrix__datepickers"
      v-loading="isLoading"
    >
      <div class="sc-tagil-matrix__datepickers__item">
        <r-text>
          {{ $t("from") }}
        </r-text>
        <el-date-picker
          class="r-date-picker"
          v-model="dateFrom"
          format="dd.MM.yyyy HH:mm"
          type="datetime"
          align="right"
          placeholder="Выберите дату и время"
          :picker-options="fromPickerOptions"
          :clearable="false"
          @change="datepickerChange"
        />
      </div>
      <div class="sc-tagil-matrix__datepickers__item">
        <r-text>
          {{ $t("to") }}
        </r-text>
        <el-date-picker
          class="r-date-picker"
          v-model="dateTo"
          format="dd.MM.yyyy HH:mm"
          type="datetime"
          align="right"
          placeholder="Выберите дату и время"
          :clearable="false"
          :picker-options="toPickerOptions"
          @change="datepickerChange"
        />
      </div>
    </div>
    <r-icon
      slot="reference"
      name="heatmap"
      :size="18"
      @click.native="toggleMatrix()"
    />
  </el-popover>
</template>

<script>
import { jsonToGeojson } from "@/utils";
import moment from "moment";

export default {
  data() {
    return {
      matrixUrl: "TagilDetectorData?format=correspondence_matrix",
      isLoading: false,
      isVisible: false,
      dateTo: null,
      dateFrom: null,
      fromPickerOptions: {
        disabledDate: this.disableFrom
      },
      toPickerOptions: {
        disabledDate: this.disableTo
      }
    };
  },
  computed: {},
  created() {
    this.setDateFrom();
    this.getMatrixData();
  },
  methods: {
    toggleMatrix() {
      this.isVisible = !this.isVisible;
      this.$store.commit("SET_SI_CENTER_TAGIL_MATRIX_PROP", {
        field: "enabled",
        value: this.isVisible
      });
    },
    disableFrom(date) {
      if (!this.dateTo) {
        return date >= new Date();
      } else {
        const toDate = new Date(this.dateTo);

        return toDate >= new Date() ? date >= new Date() : date >= toDate;
      }
    },
    disableTo(date) {
      const fromDate = new Date(this.dateFrom);
      const dateNow = new Date();

      return (
        moment(date).unix() <= moment(fromDate).unix() - 24 * 60 * 60 ||
        moment(date).unix() >= moment(dateNow).unix()
      );
    },
    setDateFrom() {
      this.dateTo = Date.now();
      this.dateFrom = this.dateTo - 24 * 60 * 60 * 1000;
    },
    datepickerChange() {
      this.getMatrixData();
    },
    async getMatrixData() {
      if (!this.matrixUrl) return;

      try {
        this.isLoading = true;
        const from = moment.utc(this.dateFrom).format();
        const to = moment.utc(this.dateTo).format();

        const url = `${this.matrixUrl}&from=${from}&to=${to}`;
        const { data } = await this.$store.dispatch("REQUEST", {
          url
        });
        const matrixData = this.prepareMatrixData(data);

        this.$store.commit("SET_SI_CENTER_TAGIL_MATRIX_PROP", {
          field: "data",
          value: matrixData
        });
        this.isLoading = false;
      } catch (e) {
        console.log(e);
        this.isLoading = false;
      }
    },
    prepareMatrixData(data) {
      const result = data
        .filter(e => {
          const equal =
            e.from_geom.coordinates[0] === e.to_geom.coordinates[0] &&
            e.from_geom.coordinates[1] === e.to_geom.coordinates[1];

          return !equal && e.value;
        })
        .map(e => {
          e.geom = {
            type: "LineString",
            coordinates: [e.from_geom.coordinates, e.to_geom.coordinates]
          };
          return e;
        });

      let min = result[0].value;
      let max = result[0].value;

      result.forEach(({ value }) => {
        if (value < min) min = value;
        if (value > max) max = value;
      });

      this.$store.commit("SET_SI_CENTER_TAGIL_MATRIX_PROP", {
        field: "max",
        value: max
      });
      this.$store.commit("SET_SI_CENTER_TAGIL_MATRIX_PROP", {
        field: "min",
        value: min
      });

      const targetData = jsonToGeojson(result);
      targetData.features = targetData.features.map(f => ({
        ...f,
        properties: {
          value: f.properties.value
        }
      }));

      return targetData;
    }
  }
};
</script>

<style lang="scss">
.sc-tagil-matrix__datepickers {
  position: relative;
  display: flex;
  flex-direction: column;
}
</style>

<i18n>
{
  "ru": {
    "from": "Начало",
    "to": "Окончание"
  },
  "en": {
    "from": "From",
    "to": "To"
  }
}
</i18n>
